// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import img1 from "../Assets/1.png"

function Projects() {
    
    const projects = [
        {
          sno: 1,
          agency: "DST-SERB",
          title: "Bone fracture analysis for type-2 Diabetic patients with osteoporosis based on experimentation and finite element modelling",
          status: "On going",
        },
        {
          sno: 2,
          agency: "MHRD-STARS",
          title: "Model Development for clinician to predict the bone and soft tissue strength and quality for type 2 Diabetic patients",
          status: "On going",
        },
        {
          sno: 3,
          agency: "DRDO-ARMREB",
          title: "Investigation on Dynamic Deformation Behavior of Tungsten Heavy Alloys (WHAs) for Defence Applications",
          status: "Awarded",
        },
        {
          sno: 4,
          agency: "DRDO-CARS",
          title: "High speed impact Dynamic and Deformation analysis of Target-projectile system using 3D-DIC Technique",
          status: "On going",
        },
        {
          sno: 5,
          agency: "SERB-IMPRINT",
          title: "Best from waste - Processing orthopaedic waste from hospitals into affordable, high-quality orthobiologics for regenerative applications",
          status: "On going",
        },
        {
          sno: 6,
          agency: "DHR",
          title: "To study the ultra and molecular changes in bone of T2DM and propose preventive and treatment strategy to overcome fragility fracture based on assessment of bone quality and quantity, mechanical properties, remodelling indices as well as genomic data in T2DM",
          status: "Awarded",
        },
        {
          sno: 7,
          agency: "ICMR",
          title: "Designing and development of a variable threaded tapered Cortico-cancello-cortical screw for high pull out strength",
          status: "Completed",
        },
        {
          sno: 8,
          agency: "DST",
          title: "Artificial Breathing Capability Device (ABCD): Design, Development, Testing and Clinical Validation",
          status: "Completed",
        },
        {
          sno: 9,
          agency: "DRDO",
          title: "Hyper Velocity impact induced deformation of the target-projectile system",
          status: "Completed",
        },
        {
          sno: 10,
          agency: "DRDO",
          title: "Finite Element Based modeling and experimental Characterization C-SiC Composite",
          status: "Completed",
        },
        {
          sno: 11,
          agency: "DST",
          title: "To design closed loop automated blood pressure control system",
          status: "",
        },
    ];

    return (
        <div className="min-h-screen overflow-x-auto p-4 font-serif">
        <table className="min-w-full bg-white border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2 border-b">S.No.</th>
              <th className="px-4 py-2 border-b">Funding Agency</th>
              <th className="px-4 py-2 border-b">Title of Project</th>
              <th className="px-4 py-2 border-b">Status</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((project, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="px-4 py-2 border-b text-center">{index+1}</td>
                <td className="px-4 py-2 border-b">{project.agency}</td>
                <td className="px-4 py-2 border-b">{project.title}</td>
                <td className="px-4 py-2 border-b text-center">{project.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
}

export default Projects;